import { Notify } from 'notiflix/build/notiflix-notify-aio';

import {
  setContactsEmail,
  setContactsSocial,
} from '@/redux/contacts/contactsSlice';

import contactsService from '@/services/contactsService';

const getContacts = () => async dispatch => {
  try {
    const response = await contactsService.getContacts();

    const {
      data: { emails, socials },
    } = response;

    dispatch(setContactsEmail(emails));
    dispatch(setContactsSocial(socials));
  } catch (e) {
    Notify.failure(e.response?.data?.message || 'Request GetContacts failure');
  }
};

export default {
  getContacts,
};
